(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDialogController', CommunicationStatusDialogController);

    CommunicationStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:communicationStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationStatus.id !== null) {
                CommunicationStatus.update(vm.communicationStatus, onSaveSuccess, onSaveError);
            } else {
                CommunicationStatus.save(vm.communicationStatus, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
